<template lang="pug">
v-app
  v-main
    router-view
</template>

<script>

export default {
  name: 'App',
};
</script>
